import React, { useState, useCallback } from 'react';

import {
    Button, Dialog, Grid, Icon, DialogTitle,
    DialogContent, DialogActions,
} from '@material-ui/core'


import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

function ImageCropModal({ src, onClose, onSave, open }) {
  const [crop, setCrop] = useState({ aspect: 16 / 9 });
  const [imageRef, setImageRef] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onImageLoaded = useCallback((image) => {
    setImageRef(image);
  }, []);

  const onCropChange = useCallback((newCrop) => {
    setCrop(newCrop);
  }, []);

  const onCropComplete = useCallback((cropArea, pixelCropArea) => {
    if (imageRef && pixelCropArea.width && pixelCropArea.height) {
      const canvas = document.createElement('canvas');
      const scaleX = imageRef.naturalWidth / imageRef.width;
      const scaleY = imageRef.naturalHeight / imageRef.height;
      canvas.width = pixelCropArea.width;
      canvas.height = pixelCropArea.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        imageRef,
        pixelCropArea.x * scaleX,
        pixelCropArea.y * scaleY,
        pixelCropArea.width * scaleX,
        pixelCropArea.height * scaleY,
        0,
        0,
        pixelCropArea.width,
        pixelCropArea.height
      );

      const croppedImageUrl = canvas.toDataURL('image/jpeg'); // You can change the format as needed
      setCroppedImage(croppedImageUrl);
    }
  }, [imageRef]);

  const handleSave = () => {
    onSave(croppedImage);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Crop Image</DialogTitle>
      <DialogContent>
        <div className="image-crop-container">
          <ReactCrop
            src={src}
            crop={crop}
            onImageLoaded={onImageLoaded}
            onChange={onCropChange}
            onComplete={onCropComplete}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ImageCropModal;